import { render, staticRenderFns } from "./WanxiangMonthlyStats.vue?vue&type=template&id=567eef63&scoped=true&"
import script from "./WanxiangMonthlyStats.vue?vue&type=script&lang=js&"
export * from "./WanxiangMonthlyStats.vue?vue&type=script&lang=js&"
import style0 from "./WanxiangMonthlyStats.vue?vue&type=style&index=0&id=567eef63&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "567eef63",
  null
  
)

export default component.exports